export const ORGANIZATION_OWNER = 'Owner';
export const ORGANIZATION_ADMINISTRATOR = 'Organization Administrator';
export const TENANT_ADMINISTRATOR = 'Tenant Administrator';
export const SUPER_ADMINISTRATOR = 'Super Administrator';
